import instance from 'src/common/http/axiosInstance';
import { mapToData } from 'src/common/http/mapToData';
import { mapToErrors } from 'src/common/http/mapToErrors';

import {
  CreateProjectTierDTO,
  ListProjectTiersResponseDTO,
  ProjectTierResponseDTO,
  ReorderProjectTiersDTO,
  UpdateProjectTierDTO,
} from './dtos';

const requests = {
  get: async <T>(url: string): Promise<T> => instance.get(url).then(mapToData).catch(mapToErrors),
  post: async <TBody, TResponse>(url: string, body: TBody): Promise<TResponse> =>
    instance.post(url, body).then(mapToData).catch(mapToErrors),
  patch: async <TBody, TResponse>(url: string, body: TBody): Promise<TResponse> =>
    instance.patch(url, body).then(mapToData).catch(mapToErrors),
  delete: async <T>(url: string): Promise<T> => instance.delete(url).then(mapToData).catch(mapToErrors),
};

export const tiersService = {
  list: async (projectId: string): Promise<ListProjectTiersResponseDTO> =>
    requests.get<ListProjectTiersResponseDTO>(`projects/${projectId}/tiers`),

  create: async (projectId: string, body: CreateProjectTierDTO): Promise<ProjectTierResponseDTO> =>
    requests.post<CreateProjectTierDTO, ProjectTierResponseDTO>(`projects/${projectId}/tiers`, body),

  update: async (projectId: string, tierId: string, body: UpdateProjectTierDTO): Promise<ProjectTierResponseDTO> =>
    requests.patch<UpdateProjectTierDTO, ProjectTierResponseDTO>(`projects/${projectId}/tiers/${tierId}`, body),

  delete: async (projectId: string, tierId: string): Promise<void> =>
    requests.delete<void>(`projects/${projectId}/tiers/${tierId}`),

  reorder: async (projectId: string, body: ReorderProjectTiersDTO): Promise<ListProjectTiersResponseDTO> =>
    requests.post<ReorderProjectTiersDTO, ListProjectTiersResponseDTO>(`projects/${projectId}/tiers/reorder`, body),
};
